import ForgotPass from "../components/Layout/Authentication/ForgotPass";

const ForgotPasswordPage = () => {
  return <ForgotPass />;
};

export default ForgotPasswordPage;
